import { Entity } from './entity';
import { environment } from '../../environments/environment';

export class SchoolbagFile extends Entity {

    name: string;
    bookLink: string;
    pdfLink: string;
    pdfOnly: boolean;
    uploadedAt: string;

    getEndpointName(): string {
        return environment.endpointUrls.schoolBagFiles;
    }

}
